import React, { useState, useEffect, SyntheticEvent, useRef } from 'react';
import {
    AccordionSummary, AccordionDetails, Typography, Box, Button, Grid2, Divider, Autocomplete, TextField, ListItem, ListItemText, List, Stack, Link, InputLabel, Select, MenuItem, SelectChangeEvent, Chip
} from '@mui/material'
import CustomAccordion from '../../../components/Accordian/accordian';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useFetchReservationDetailsQuery, usePatchReservationDetailsMutation, useGetAvailableUnitsDataQuery } from '../../../api/endpoints/apiConfig';
import dayjs, { Dayjs } from 'dayjs';
import { AvailableUnit } from '../../../models/AvailableUnits';
import { DataGrid, GridColDef, GridRenderCellParams, GridTreeNodeWithRender } from '@mui/x-data-grid';
import { Promotion } from '../../../models/Promotions';
import { useNavigate } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import { AircallNofity } from '../../../components/Common/notify';
import { addId } from '../../../store/reducers/aircallTagSlice';
import { useAppDispatch } from '../../../hooks/useAppDispatch';
type Props = {
    facilityId: number;
    dealId: number;
    onUpdate: () => void;
    data: any;
    unittypeid: any;
    selectedOccupant?: any;
    onLookupTenant?: () => void;
};
interface FormState {
    email: string;
    lastname: string;
    phNum: string;
    firstname: string;
    external_occupant_id?: string;
}

const phoneDigitsOnly = (value: string): string => value.replace(/\D/g, '');

/** Formats up to 10 digits as (xxx) yyy-zzzz while typing */
const formatPhoneInputValue = (raw: string): string => {
    const d = phoneDigitsOnly(raw).slice(0, 10);
    if (d.length === 0) return '';
    if (d.length <= 3) return `(${d}`;
    if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
    return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
};

const UpdateReservation = ({ facilityId, dealId, onUpdate, data, unittypeid, selectedOccupant, onLookupTenant }: Props) => {
    const { data: reservationDetails, refetch } = useFetchReservationDetailsQuery({
        facilityId,
        dealId,
    });
    const { data: responseData, isLoading } = useGetAvailableUnitsDataQuery(facilityId);
    const [moveInDate, setMoveInDate] = useState<Dayjs | null>(null);
    const [FollowDate, setFollowDate] = useState<Dayjs | null>(null);
    const [moveInMinDates, setmoveInMinDates] = useState<Dayjs | null>(null);
    const [isLookup, setIsLookup] = useState(false); // Renamed from Islookup to isLookup
    const [patchReservationDetails] = usePatchReservationDetailsMutation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch(); // Initialize dispatch
    // Setting Data Read from the session storage
    const SettingData = sessionStorage.getItem('setting');
    const Settings = SettingData ? JSON.parse(SettingData) : [];
    const IsLead = Settings.is_deal_type_lead_enabled;
    const maxdate = Settings.deal_lead_time_days;
    // const minDate = dayjs(); // Current date
    const [formData, setFormData] = useState<FormState>({
        email: '',
        lastname: '',
        phNum: '',
        firstname: '',
        external_occupant_id: '',
    });
    const [errors, setErrors] = useState({
        firstname: false,
        lastname: false,
        phNum: false,
        email: false,
        followupDate: false,
    });
    const [selectedUnit, setSelectedUnit] = useState(
        {
            unitSize: '',
            productType: '',
            rate: 0,
            promotion: '',
            external_unit_id: data?.external_unit_id,
            external_promotion_id: '',
            external_product_type_id: '',
            Features: "",
            floor: 0 as number | undefined,
            width: 0 as number | undefined,
            length: 0 as number | undefined,
            inside: 0 as number | undefined,
            drive_up: 0 as number | undefined,
            climate: 0 as number | undefined,
            air_cooled: 0 as number | undefined,
            heated: 0 as number | undefined,
            elevator: 0 as number | undefined,
            stair_access: 0 as number | undefined,
            external_type_id: '' as string | undefined,
        }
    );
    const facilityData = JSON.parse(sessionStorage.getItem('facilityData') || '[]');
    const promotions: Promotion[] = facilityData[0]?.promotions || [];
    const promoMap: Record<string, string> = promotions.reduce((map: Record<string, string>, promo: Promotion) => {
        const key = String(promo.external_id ?? '').trim();
        if (key) map[key] = promo.name;
        return map;
    }, {});
    const dealPromoId = reservationDetails?.deal?.external_promotion_id;
    const promotionName =
        dealPromoId != null && String(dealPromoId).trim() !== ''
            ? promoMap[String(dealPromoId).trim()] || ''
            : '';
    const [loading, setLoading] = useState(false);
    const [updatedDealPrice, setUpdatedDealPrice] = useState<number>(0);
    const hasSyncedSelectedUnitFromDeal = useRef(false);

    const formatUnitFeatures = (unit: {
        floor?: number;
        inside?: number;
        is_inside?: number;
        drive_up?: number;
        is_drive_up?: number;
        climate?: number;
        is_climate?: number;
        air_cooled?: number;
        is_air_cooled?: number;
        heated?: number;
        is_heated?: number;
        elevator?: number;
        is_elevator?: number;
        stair_access?: number;
        is_stair_access?: number;
    } | null | undefined): string => {
        if (!unit) return 'No unit details available';
        const features: string[] = [];
        const floor = unit.floor;
        const inside = unit.inside ?? unit.is_inside;
        const driveUp = unit.drive_up ?? unit.is_drive_up;
        const climate = unit.climate ?? unit.is_climate;
        const airCooled = unit.air_cooled ?? unit.is_air_cooled;
        const heated = unit.heated ?? unit.is_heated;
        const elevator = unit.elevator ?? unit.is_elevator;
        const stairAccess = unit.stair_access ?? unit.is_stair_access;
        if (floor === 1) features.push('First Floor');
        if (floor !== undefined && floor > 1) features.push('Upper');
        if (inside) features.push('Inside');
        if (driveUp) features.push('Drive Up');
        if (climate) features.push('Climate');
        if (airCooled) features.push('Air Cooled');
        if (heated) features.push('Heated');
        if (elevator) features.push('Elevator Access');
        if (stairAccess) features.push('Stair Access');
        return features.join(', ') || 'No unit details available';
    };



    // Log the fetched data
    useEffect(() => {
        if (reservationDetails) {
            console.log('Reservation Details', reservationDetails)
            const initialMoveInDate = dayjs(reservationDetails.deal?.move_in_date);
            const todaydate = dayjs();
            const minDates = initialMoveInDate?.isAfter(todaydate) || initialMoveInDate?.isBefore(todaydate) ? todaydate : initialMoveInDate;
            const Followupdate = dayjs(reservationDetails.deal?.followup_at);
            setmoveInMinDates(minDates)
            setMoveInDate(initialMoveInDate.isValid() ? initialMoveInDate : null);
            setFollowDate(Followupdate.isValid() ? Followupdate : null)
            setFormData((prevData) => ({
                ...prevData,
                firstname: reservationDetails.deal?.first_name,
                lastname: reservationDetails.deal?.last_name,
                phNum: formatPhoneInputValue(String(reservationDetails.deal?.phone ?? '')),
                email: reservationDetails.deal?.email,
                external_occupant_id: reservationDetails.deal?.external_occupant_id || ''

            }));
            setSelectedUnit({
                unitSize: reservationDetails?.deal?.unit_dimensions || '',
                productType: reservationDetails.deal?.type || '',
                rate: reservationDetails?.deal?.quoted_price || 0,
                promotion: promotionName,
                external_unit_id: reservationDetails?.deal?.external_unit_id,
                external_promotion_id: reservationDetails?.deal?.external_promotion_id || '',
                external_product_type_id: '',
                Features: formatUnitFeatures(reservationDetails?.deal?.unit),
                floor: reservationDetails?.deal?.unit?.floor,
                width: reservationDetails?.deal?.unit?.width,
                length: reservationDetails?.deal?.unit?.length,
                inside: reservationDetails?.deal?.unit?.is_inside,
                drive_up: reservationDetails?.deal?.unit?.is_drive_up,
                climate: reservationDetails?.deal?.unit?.is_climate,
                air_cooled: reservationDetails?.deal?.unit?.is_air_cooled,
                heated: reservationDetails?.deal?.unit?.is_heated,
                elevator: reservationDetails?.deal?.unit?.is_elevator,
                stair_access: reservationDetails?.deal?.unit?.is_stair_access,
                external_type_id: reservationDetails?.deal?.unit?.external_unit_type_id,
            });
            setUpdatedDealPrice(reservationDetails?.deal?.quoted_price ?? 0);
            hasSyncedSelectedUnitFromDeal.current = true;
        }
    }, [reservationDetails, promotionName]);// eslint-disable-line react-hooks/exhaustive-deps

    // Handle selectedOccupant changes
    useEffect(() => {
        if (selectedOccupant) {
            setFormData((prevData) => ({
                ...prevData,
                firstname: selectedOccupant.firstname,
                lastname: selectedOccupant.lastname,
                phNum: selectedOccupant.phNum,
                email: selectedOccupant.email,
                external_occupant_id: selectedOccupant.external_id
            }));
        }
    }, [selectedOccupant]);

    const handleUnitChange = (
        event: SyntheticEvent<Element, Event>,
        value: { unit_number: string; external_id: string } | null
    ) => {
        if (value) {
            setSelectedUnit((prev) => ({ ...prev, external_unit_id: value.external_id }));
        }
    };

    // Prepare row data
    const availableUnits: AvailableUnit[] = responseData?.available_units || [];
    const rowData = availableUnits.map(unit => ({
        id: unit.id,
        unitSize: `${unit.width > 0 ? unit.width + "' x " + unit.length + "'" : unit.length + "'"}
            <br/>${formatUnitFeatures(unit)}`,
        productType: unit.type_name,
        price: `$${unit.price.toFixed(2)}`,
        priceNum: unit.price,
        promotion: unit.promotion_text || 'No Promo',
        facility_id: unit.facility_id,
        external_unit_id: unit.external_unit_id,
        width: unit.width,
        length: unit.length,
        area: unit.area,
        floor: unit.floor,
        price_formatted: unit.price_formatted,
        external_promotion_id: unit.external_promotion_id,
        promotion_text: unit.promotion_text,
        external_type_id: unit.external_type_id,
        type_name: unit.type_name,
        is_insurable: unit.is_insurable ?? null,
        alarm: unit.alarm,
        power: unit.power,
        inside: unit.inside,
        drive_up: unit.drive_up ?? 0,
        climate: unit.climate,
        air_cooled: unit.air_cooled ?? 0,
        heated: unit.heated ?? 0,
        elevator: unit.elevator ?? 0,
        stair_access: unit.stair_access ?? 0,
        mobile: unit.mobile,
        total_units: unit.total_units,
        total_occupied: unit.total_occupied,
        total_vacant: unit.total_vacant,
        total_reserved: unit.total_reserved,
        units: unit.units ?? [],
        created_at: unit.created_at,
        updated_at: unit.updated_at,
    }));

    // Find matching unit type from available_units by width, length, product_type_id, inside, drive_up, climate, air_cooled, heated, elevator, stair_access, price
    const findMatchingUnitType = (
        width?: number,
        length?: number,
        productTypeId?: string | number,
        inside?: number,
        driveUp?: number,
        climate?: number,
        airCooled?: number,
        heated?: number,
        elevator?: number,
        stairAccess?: number,
        price?: number
    ) => {
        return availableUnits.find((u) => {
            const wMatch = Number(u.width ?? 0) === Number(width ?? 0);
            const lMatch = Number(u.length ?? 0) === Number(length ?? 0);
            const typeMatch = String(u.external_type_id ?? '') === String(productTypeId ?? '');
            const insideMatch = Number(u.inside ?? 0) === Number(inside ?? 0);
            // Skip drive_up check when deal/selectedUnit doesn't have the value (e.g. legacy units, missing unitType)
            const driveUpMatch = driveUp === undefined ? true : Number(u.drive_up ?? 0) === Number(driveUp ?? 0);
            const climateMatch = Number(u.climate ?? 0) === Number(climate ?? 0);
            const airCooledMatch = airCooled === undefined ? true : Number(u.air_cooled ?? 0) === Number(airCooled ?? 0);
            const heatedMatch = heated === undefined ? true : Number(u.heated ?? 0) === Number(heated ?? 0);
            const elevatorMatch = elevator === undefined ? true : Number(u.elevator ?? 0) === Number(elevator ?? 0);
            const stairAccessMatch = stairAccess === undefined ? true : Number(u.stair_access ?? 0) === Number(stairAccess ?? 0);
            const priceMatch = Math.abs(Number(u.price ?? 0) - Number(price ?? 0)) < 0.01;
            return wMatch && lMatch && typeMatch && insideMatch && driveUpMatch && climateMatch && airCooledMatch && heatedMatch && elevatorMatch && stairAccessMatch && priceMatch;
        });
    };

    // Find matching unit type without price (width, length, product_type, inside, drive_up, climate, air_cooled, heated, elevator, stair_access only) - for price-changed scenario
    const findMatchingUnitTypeWithoutPrice = (
        width?: number,
        length?: number,
        productTypeId?: string | number,
        inside?: number,
        driveUp?: number,
        climate?: number,
        airCooled?: number,
        heated?: number,
        elevator?: number,
        stairAccess?: number
    ) => {
        return availableUnits.find((u) => {
            const wMatch = Number(u.width ?? 0) === Number(width ?? 0);
            const lMatch = Number(u.length ?? 0) === Number(length ?? 0);
            const typeMatch = String(u.external_type_id ?? '') === String(productTypeId ?? '');
            const insideMatch = Number(u.inside ?? 0) === Number(inside ?? 0);
            const driveUpMatch = driveUp === undefined ? true : Number(u.drive_up ?? 0) === Number(driveUp ?? 0);
            const climateMatch = Number(u.climate ?? 0) === Number(climate ?? 0);
            const airCooledMatch = airCooled === undefined ? true : Number(u.air_cooled ?? 0) === Number(airCooled ?? 0);
            const heatedMatch = heated === undefined ? true : Number(u.heated ?? 0) === Number(heated ?? 0);
            const elevatorMatch = elevator === undefined ? true : Number(u.elevator ?? 0) === Number(elevator ?? 0);
            const stairAccessMatch = stairAccess === undefined ? true : Number(u.stair_access ?? 0) === Number(stairAccess ?? 0);
            return wMatch && lMatch && typeMatch && insideMatch && driveUpMatch && climateMatch && airCooledMatch && heatedMatch && elevatorMatch && stairAccessMatch;
        });
    };

    // Exact match (with price)
    const matchingUnitType = findMatchingUnitType(
        selectedUnit.width,
        selectedUnit.length,
        selectedUnit.external_type_id,
        selectedUnit.inside,
        selectedUnit.drive_up,
        selectedUnit.climate,
        selectedUnit.air_cooled,
        selectedUnit.heated,
        selectedUnit.elevator,
        selectedUnit.stair_access,
        parseFloat(String(selectedUnit.rate ?? 0).replace(/[$,]/g, ''))
    );
    // Match without price - when unit price changed but dimensions/type match
    const matchingUnitTypePriceChanged = findMatchingUnitTypeWithoutPrice(
        selectedUnit.width,
        selectedUnit.length,
        selectedUnit.external_type_id,
        selectedUnit.inside,
        selectedUnit.drive_up,
        selectedUnit.climate,
        selectedUnit.air_cooled,
        selectedUnit.heated,
        selectedUnit.elevator,
        selectedUnit.stair_access
    );

    // Unit options: use exact match if found, else use price-changed match (preserves deal price)
    const effectiveUnitType = matchingUnitType ?? matchingUnitTypePriceChanged;
    const handleRentNavigate = () => {
        const rentalData = {
            promotion: promotionName,
            facilityId: facilityId,
            externalUnitId: reservationDetails?.deal?.external_unit_id,
            external_promotion_id: selectedUnit.external_promotion_id,
            externalId: reservationDetails?.deal.external_id,
            is_insurable: effectiveUnitType?.is_insurable ?? null,
            label: "convert"
        };
        // Navigate to the Rent page with both IDs and state
        navigate(`/rent/${rentalData.facilityId}/deal/${rentalData.externalId}`, { state: { rentalData } });
    };
    const unitOptions: { external_id: string; unit_number: string }[] =
        effectiveUnitType?.units?.length
            ? effectiveUnitType.units.map((u: { id: number; unit_number: string }) => ({
                  external_id: u.id.toString(),
                  unit_number: u.unit_number,
              }))
            : [];
    // Price changed: exact match fails but match without price succeeds (dimensions/type same, price different)
    const hasPriceChangedMatch =
        matchingUnitType == null &&
        matchingUnitTypePriceChanged != null &&
        (matchingUnitTypePriceChanged.units?.length ?? 0) > 0 &&
        reservationDetails?.deal?.unit != null &&
        hasSyncedSelectedUnitFromDeal.current;

    // Only consider "no match" when neither exact nor price-changed match exists
    const hasNoMatch =
        reservationDetails?.deal?.unit != null &&
        hasSyncedSelectedUnitFromDeal.current &&
        responseData != null &&
        !effectiveUnitType;

    // Unit type exists but deal's unit number is not in the units array (e.g. unit was rented)
    const dealUnitId = reservationDetails?.deal?.external_unit_id;
    const unitNotInUnitsArray =
        effectiveUnitType != null &&
        (effectiveUnitType.units?.length ?? 0) > 0 &&
        dealUnitId != null &&
        dealUnitId !== '' &&
        !effectiveUnitType.units.some((u: { id: number }) => String(u.id) === String(dealUnitId));

    const hasShownNoMatchSnackbar = useRef(false);
    const hasShownNewProductTypeSnackbar = useRef(false);
    const userHasSelectedFromGrid = useRef(false);
    const dealUnitReplacementPatchRef = useRef(false);

    // Scenario 1 (price change only): no snackbar per spec

    // Check if a row matches the deal's current unit (width, length, product_type, inside, drive_up, climate, air_cooled, heated, elevator, stair_access)
    const isCurrentDealUnit = (row: { width?: number; length?: number; type_name?: string; external_type_id?: string; inside?: number; drive_up?: number; climate?: number; air_cooled?: number; heated?: number; elevator?: number; stair_access?: number }) => {
        const dealUnit = reservationDetails?.deal?.unit;
        if (!dealUnit) return false;
        const widthMatch = Number(dealUnit.width ?? 0) === Number(row.width ?? 0);
        const lengthMatch = Number(dealUnit.length ?? 0) === Number(row.length ?? 0);
        const productTypeMatch =
            String(reservationDetails?.deal?.type ?? '').trim() === String(row.type_name ?? '').trim() ||
            String(dealUnit.external_unit_type_id ?? '').trim() === String(row.external_type_id ?? '').trim();
        const insideMatch = Number(dealUnit.is_inside ?? 0) === Number(row.inside ?? 0);
        // Skip when deal unit doesn't have the value (e.g. legacy units, missing unitType)
        const driveUpMatch = dealUnit.is_drive_up === undefined ? true : Number(dealUnit.is_drive_up ?? 0) === Number(row.drive_up ?? 0);
        const climateMatch = Number(dealUnit.is_climate ?? 0) === Number(row.climate ?? 0);
        const airCooledMatch = dealUnit.is_air_cooled === undefined ? true : Number(dealUnit.is_air_cooled ?? 0) === Number(row.air_cooled ?? 0);
        const heatedMatch = dealUnit.is_heated === undefined ? true : Number(dealUnit.is_heated ?? 0) === Number(row.heated ?? 0);
        const elevatorMatch = dealUnit.is_elevator === undefined ? true : Number(dealUnit.is_elevator ?? 0) === Number(row.elevator ?? 0);
        const stairAccessMatch = dealUnit.is_stair_access === undefined ? true : Number(dealUnit.is_stair_access ?? 0) === Number(row.stair_access ?? 0);
        return widthMatch && lengthMatch && productTypeMatch && insideMatch && driveUpMatch && climateMatch && airCooledMatch && heatedMatch && elevatorMatch && stairAccessMatch;
    };

    // Single row to highlight: 1) exact match (price + dimensions) if exists; else 2) match on dimensions only.
    const highlightedRowId = (() => {
        const dealUnit = reservationDetails?.deal?.unit;
        const dealPrice = reservationDetails?.deal?.quoted_price ?? 0;
        const dealUnitId = reservationDetails?.deal?.external_unit_id ?? '';
        if (!dealUnit) return null;
        const dimMatch = (r: (typeof rowData)[0]) => isCurrentDealUnit(r);
        const priceMatch = (r: (typeof rowData)[0]) => Math.abs(Number(dealPrice) - Number(r.priceNum ?? 0)) < 0.01;
        const unitIdMatch = (r: (typeof rowData)[0]) => String(r.external_unit_id ?? '') === String(dealUnitId);
        const fullMatch = (r: (typeof rowData)[0]) => dimMatch(r) && priceMatch(r);
        const fullMatches = rowData.filter(fullMatch);
        if (fullMatches.length > 0) {
            const byDealUnit = fullMatches.find(unitIdMatch);
            return (byDealUnit ?? fullMatches[0]).id;
        }
        const dimMatches = rowData.filter(dimMatch);
        if (dimMatches.length > 0) {
            const byDealUnit = dimMatches.find(unitIdMatch);
            return (byDealUnit ?? dimMatches[0]).id;
        }
        return null;
    })();

    const shouldHighlightRow = (row: { id?: number }) => row.id != null && highlightedRowId != null && row.id === highlightedRowId;

    const Setunitdata = (params: any) => {
        userHasSelectedFromGrid.current = true;
        const data = params.row;
        const isMatch = isCurrentDealUnit(data);
        if (!isMatch) {
            const unitPrice = data.priceNum ?? (parseFloat(String(data.price_formatted || '0').replace(/[$,]/g, '')) || 0);
            setUpdatedDealPrice(unitPrice);
        }
        setSelectedUnit((prevData) => ({
            ...prevData,
            unitSize: `${data.width > 0 ? data.width + "' x " + data.length + "'" : data.length + "'"}`,
            productType: data.type_name,
            rate: data.price_formatted,
            promotion: isMatch ? promotionName : data.promotion,
            external_unit_id: data.external_unit_id,
            external_promotion_id: isMatch ? (reservationDetails?.deal?.external_promotion_id || '') : data.external_promotion_id,
            external_product_type_id: data.external_type_id,
            Features: formatUnitFeatures(data),
            floor: data.floor,
            width: data.width,
            length: data.length,
            inside: data.inside,
            drive_up: data.drive_up ?? 0,
            climate: data.climate,
            air_cooled: data.air_cooled ?? 0,
            heated: data.heated ?? 0,
            elevator: data.elevator ?? 0,
            stair_access: data.stair_access ?? 0,
            external_type_id: data.external_type_id,
        }));
        setIsLookup(false);
    }
    // Email validate and onchange function
    const validateEmail = (email: string): boolean => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };
    // email handleBlur
    const handleBlur = () => {
        if (!validateEmail(formData.email)) {
            setErrors({
                ...errors,
                email: true,
            });
        } else {
            setErrors({
                ...errors,
                email: false,
            });
        }
    };
    const handlePhoneBlur = () => {
        const d = phoneDigitsOnly(formData.phNum);
        setErrors((prev) => ({
            ...prev,
            phNum: d.length !== 10,
        }));
    };
    //on change
    const selectChange = (params: GridRenderCellParams<any>) => {
        if (!params.row) {
            console.error("Params or row is undefined", params);
            return;
        }
        Setunitdata(params);

        // Correctly update selected unit
        setSelectedUnit((prev) => ({
            ...prev,
            external_unit_id: params.row.external_unit_id,
            unit_number: params.row.unit_number,
        }));
    };

    // Show msg only when selected unit does NOT match deal (use same logic as isCurrentDealUnit for consistency)
    const selectedUnitAsRow = {
        width: selectedUnit.width,
        length: selectedUnit.length,
        inside: selectedUnit.inside,
        drive_up: selectedUnit.drive_up,
        climate: selectedUnit.climate,
        air_cooled: selectedUnit.air_cooled,
        heated: selectedUnit.heated,
        elevator: selectedUnit.elevator,
        stair_access: selectedUnit.stair_access,
        type_name: selectedUnit.productType,
        external_type_id: selectedUnit.external_type_id,
    };
    const isMatch = reservationDetails?.deal?.unit != null && isCurrentDealUnit(selectedUnitAsRow);
    const showNewProductTypeMsg = reservationDetails?.deal?.unit != null && !isMatch;

    // Show snackbar when unit is no longer available (once) - only when user has NOT selected a different unit from Available Units
    const showNoLongerAvailableError = (hasNoMatch || unitNotInUnitsArray) && !showNewProductTypeMsg;
    // Scenario 2/4: unit rented, others available; Scenario 3/5: unit rented, no others available
    const othersAvailable = unitNotInUnitsArray && unitOptions.length > 0;
    const noOthersAvailable = hasNoMatch || (unitNotInUnitsArray && unitOptions.length === 0);
    useEffect(() => {
        const shouldShow = showNoLongerAvailableError && !hasShownNoMatchSnackbar.current;
        if (shouldShow) {
            hasShownNoMatchSnackbar.current = true;
            const msg = othersAvailable
                ? 'The unit is no longer available. The system has auto-selected the next available unit in the price group.'
                : 'The original unit has been rented. There are no more available units in this price group. Please select a new unit using the Available Units button below.';
            AircallNofity({
                type: othersAvailable ? 'info' : 'error',
                Msg: msg,
            });
        }
    }, [showNoLongerAvailableError, othersAvailable]);

    // Scenario 2/4: Deal unit not in unit-type-price list — auto-select first available unit, PATCH deal, refetch
    // COMMENTED OUT: conditional PATCH deal on page load (temporarily disabled)
    // useEffect(() => {
    //     if (
    //         !unitNotInUnitsArray ||
    //         unitOptions.length === 0 ||
    //         !reservationDetails?.deal ||
    //         !hasSyncedSelectedUnitFromDeal.current
    //     ) {
    //         return;
    //     }
    //     const firstOption = unitOptions[0];
    //     const newUnitId = String(firstOption.external_id);
    //     const deal = reservationDetails.deal;
    //
    //     const currentId = selectedUnit?.external_unit_id;
    //     const currentIsValid = unitOptions.some((u) => String(u.external_id) === String(currentId));
    //     if (!currentIsValid) {
    //         setSelectedUnit((prev) => ({ ...prev, external_unit_id: newUnitId }));
    //     }
    //
    //     if (String(deal.external_unit_id) === newUnitId) {
    //         return;
    //     }
    //     if (dealUnitReplacementPatchRef.current) {
    //         return;
    //     }
    //     dealUnitReplacementPatchRef.current = true;
    //
    //     const agentName =
    //         (sessionStorage.getItem('FirstName') || '') + ' ' + (sessionStorage.getItem('LastName') || '');
    //     const followupFromDeal = dayjs(deal.followup_at);
    //     const followupDateStr = followupFromDeal.isValid()
    //         ? followupFromDeal.format('YYYY-MM-DD')
    //         : dayjs().add(5, 'day').format('YYYY-MM-DD');
    //     const moveInFromDeal = dayjs(deal.move_in_date);
    //     const moveInDateStr =
    //         moveInFromDeal.isValid() && !moveInFromDeal.isBefore(dayjs(), 'day')
    //             ? moveInFromDeal.format('YYYY-MM-DD')
    //             : dayjs().format('YYYY-MM-DD');
    //     const body = {
    //         first_name: deal.first_name,
    //         last_name: deal.last_name,
    //         email: deal.email,
    //         phone: deal.phone,
    //         quoted_rate: deal.quoted_price ?? 0,
    //         type: deal.type ?? 'N/A',
    //         move_in_date: moveInDateStr,
    //         followup_date: followupDateStr,
    //         external_unit_id: newUnitId,
    //         external_promotion_id: deal.external_promotion_id,
    //         external_product_type_id: String(deal.unit?.external_unit_type_id ?? ''),
    //         status: deal.status ?? 'N/A',
    //         agent: agentName,
    //         ...(deal.external_occupant_id &&
    //             deal.external_occupant_id !== '' && { external_occupant_id: deal.external_occupant_id }),
    //     };
    //
    //     (async () => {
    //         try {
    //             await patchReservationDetails({
    //                 facilityId,
    //                 dealId,
    //                 body,
    //             }).unwrap();
    //             await refetch();
    //             onUpdate();
    //             AircallNofity({
    //                 type: 'success',
    //                 Msg: 'Deal has been updated to have a new unit number.',
    //             });
    //         } catch (e) {
    //             console.error('Failed to update deal unit to available unit:', e);
    //             dealUnitReplacementPatchRef.current = false;
    //             AircallNofity({
    //                 type: 'error',
    //                 Msg: 'Could not update the deal to the replacement unit. Please try again.',
    //             });
    //         }
    //     })();
    // }, [
    //     unitNotInUnitsArray,
    //     unitOptions,
    //     reservationDetails,
    //     facilityId,
    //     dealId,
    //     patchReservationDetails,
    //     refetch,
    //     onUpdate,
    // ]);

    // Show snackbar only when user selects a new product type from Available Units grid (not on page load)
    useEffect(() => {
        if (showNewProductTypeMsg && userHasSelectedFromGrid.current && !hasShownNewProductTypeSnackbar.current) {
            hasShownNewProductTypeSnackbar.current = true;
            AircallNofity({
                type: 'info',
                Msg: 'New unit has been selected. If the unit size, features, or type has changed, then the price is probably different also. Use the update button to apply the change.',
            });
        }
    }, [showNewProductTypeMsg]);

    // pick up unit grid column def - flex columns shrink together when viewport narrows
    const colDefs: GridColDef[] = [
        {
            field: 'unitSize',
            headerName: 'Unit Size',
            flex: 1,
            minWidth: 120,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <div
                    className="gridCell"
                    dangerouslySetInnerHTML={{ __html: params.value }}
                />
            ),
        },
        {
            field: 'productType',
            headerName: 'Product Type',
            flex: 1,
            minWidth: 100,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'price',
            headerName: 'Rate',
            flex: 0.5,
            minWidth: 60,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'promotion',
            headerName: 'Promotion',
            flex: 1,
            minWidth: 100,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'total_vacant',
            headerName: 'Available',
            flex: 0.5,
            minWidth: 60,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'current_size',
            headerName: '',
            flex: 0.8,
            minWidth: 100,
            headerAlign: 'center',
            align: 'center',
            sortable: false,
            renderCell: (params) => {
                const dealPrice = reservationDetails?.deal?.quoted_price ?? 0;
                const rowPrice = params.row.priceNum ?? (parseFloat(String(params.row.price ?? '0').replace(/[$,]/g, '')) || 0);
                const priceMatch = Math.abs(Number(dealPrice) - Number(rowPrice)) < 0.01;
                const fullMatch = isCurrentDealUnit(params.row) && priceMatch;
                return fullMatch ? (
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', width: '100%' }}>
                        <Chip label="Current Selection" size="small" variant="filled" sx={{ bgcolor: '#c8e6c9', color: 'black' }} />
                    </Box>
                ) : null;
            },
        },
        {
            field: 'action',
            headerName: 'Action',
            flex: 0.6,
            minWidth: 90,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <div className="buttonContainer">
                    <div className="buttonGroup">
                        <Button
                            size="small"
                            variant="contained"
                            onClick={() => selectChange(params)}
                        >
                            Select
                        </Button>

                    </div>
                </div>
            ),
        },
    ];
    // text box onchange events and validation
    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        if (name === 'firstname' || name === 'lastname') {
            if (value === null || value.trim() === "") {
                setErrors({
                    ...errors,
                    [name]: true,
                });
                setFormData({
                    ...formData,
                    [name]: value,
                });
                return;
            }
            else {
                setErrors({
                    ...errors,
                    [name]: false,
                });

                setFormData({
                    ...formData,
                    [name]: value,
                });
            }
        }
        else if (name === 'phNum') {
            const formattedValue = formatPhoneInputValue(value);
            setFormData({
                ...formData,
                [name]: formattedValue,
            });
            const d = phoneDigitsOnly(formattedValue);
            if (d.length === 10) {
                setErrors((prev) => ({ ...prev, phNum: false }));
            }
        }
        else {
            setFormData({
                ...formData,
                [name]: value,
            });
        }
    };
    const tagdatasave = () => {
        // Retrieve and parse tag data from sessionStorage
        const tagdata = sessionStorage.getItem('tagsdata');
        const tagdataObject = tagdata ? JSON.parse(tagdata) : {};
        const tags = tagdataObject.tags || [];
        // Find tags based on names
        const Reservationupdate = tags.find((tag: { name: string }) => tag.name === 'Reservation - Updated');
        const IsLeaddataupdate = tags.find((tag: { name: string }) => tag.name === 'Lead - Updated');

        // Ensure the required IDs exist before dispatching
        dispatch(addId(Reservationupdate?.id));
        if (IsLead) {
            dispatch(addId(IsLeaddataupdate.id));
        }
    };
    const handleUpdate = async () => {
        let save = true;
        if (!reservationDetails) return;
        const deal = reservationDetails.deal;
        // S360 sets type to "rental" for converted rentals; other PMSes often keep type as reservation/deal
        // and only set status to "converted". Backend Reservation::RENTAL = 3 can appear for some SiteLink paths.
        const typeRaw = deal?.type;
        const typeNorm = String(typeRaw ?? '').toLowerCase();
        const statusNorm = String(deal?.status ?? '').toLowerCase();
        const isRentalConstant =
            (typeof typeRaw === 'number' && typeRaw === 3) ||
            (typeof typeRaw === 'string' && typeRaw.trim() === '3');
        const isNoLongerUpdatable =
            statusNorm === 'converted' || typeNorm === 'rental' || isRentalConstant;
        if (isNoLongerUpdatable) {
            AircallNofity({
                type: 'error',
                Msg: 'Updates are no longer allowed on this deal because it has been converted. Please return to the Facility Page.',
            });
            return;
        }
        const phoneSubmit = phoneDigitsOnly(formData.phNum);
        setLoading(true);
        tagdatasave();
        try {
            // Destructure reservationDetails.deal
            const { type, status } = reservationDetails.deal || {};
            var agentName = sessionStorage.getItem('FirstName') + ' ' + sessionStorage.getItem('LastName');
            const updatedReservation = {
                first_name: formData.firstname,
                last_name: formData.lastname,
                email: formData.email,
                phone: phoneSubmit,
                quoted_rate: showNewProductTypeMsg ? (Number(updatedDealPrice) || 0) : (Number(reservationDetails?.deal?.quoted_price) || 0),
                type: type ?? 'N/A',
                move_in_date: moveInDate ? moveInDate.format('YYYY-MM-DD') : 'N/A',
                followup_date: FollowDate ? FollowDate.format('YYYY-MM-DD') : 'N/A',
                external_unit_id: selectedUnit.external_unit_id,
                external_promotion_id: selectedUnit.external_promotion_id,
                external_product_type_id: String(
                    selectedUnit.external_type_id ?? reservationDetails.deal?.unit?.external_unit_type_id ?? ''
                ),
                status: status ?? 'N/A',
                agent: agentName,
                ...(formData.external_occupant_id && formData.external_occupant_id !== '' && { external_occupant_id: formData.external_occupant_id }),
                //notes: null,
            };
            // Valid unit = in unitOptions when dropdown has options, or from available_units grid when no matching type
            const validUnitIds = new Set(
                availableUnits.flatMap((u) => [String(u.external_unit_id), ...(u.units?.map((x) => String(x.id)) ?? [])])
            );
            const hasValidUnitSelection =
                selectedUnit.external_unit_id != null &&
                selectedUnit.external_unit_id !== '' &&
                (unitOptions.length > 0
                    ? unitOptions.some((u) => String(u.external_id) === String(selectedUnit.external_unit_id))
                    : validUnitIds.has(String(selectedUnit.external_unit_id)));

            if (!hasValidUnitSelection) {
                save = false;
                AircallNofity({ type: 'error', Msg: 'Select a unit number' });
            }
            if (moveInDate && dayjs(moveInDate).isBefore(dayjs(), 'day')) {
                save = false;
                AircallNofity({ type: 'error', Msg: 'Move-in date cannot be in the past.' });
            }
            if (!FollowDate || !FollowDate.isValid()) {
                save = false;
                setErrors({
                    ...errors,
                    followupDate: true,
                });
                AircallNofity({ type: 'error', Msg: 'Follow-up date is required.' });
            }
            if (phoneSubmit.length !== 10) {
                save = false;
                setErrors((prev) => ({
                    ...prev,
                    phNum: true,
                }));
                AircallNofity({ type: 'error', Msg: 'Enter a valid 10-digit phone number.' });
            }
            if (save) {
                await patchReservationDetails({
                    facilityId,
                    dealId,
                    body: updatedReservation,
                }).unwrap();

                AircallNofity({ type: 'success', Msg: ' Update reservation successfully' });
                onUpdate();
                refetch();
            }

        } catch (error) {
            console.error('Failed to update the reservation:', error);
            AircallNofity({ type: 'error', Msg: 'Failed to update the reservation. Please try again' });
        } finally {
            setLoading(false);  // Stop showing the loader
        }
    };
    const handleLookupTenant = () => {
        setIsLookup(true);
        requestAnimationFrame(() => {
            const element = document.getElementById('occupant-info');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        });
    };
    const [calendarRestrictions, setCalendarRestrictions] = useState<{
        followMinDate: Dayjs | null;
        followMaxDate: Dayjs | null;
    }>({
        followMinDate: null,
        followMaxDate: null,
    });
    const CustomNoResultsOverlay = () => (
        <Box textAlign="center" p={2}>
            <Typography variant="h6">No Data Available</Typography>
        </Box>
    );
    useEffect(() => {
        if (moveInDate) {
            const today = dayjs();
            const tomorrow = today.add(1, 'day');

            if (moveInDate.isSame(today, 'day') || moveInDate.isSame(tomorrow, 'day')) {
                // Case: Move-in date = Today or Tomorrow
                // setFollowDate(tomorrow);
                setCalendarRestrictions({
                    followMinDate: tomorrow,
                    followMaxDate: null,
                });
            } else {
                // Case: Move-in date = +2 Days or More
                const oneDayBeforeMoveIn = moveInDate.subtract(1, 'day');
                //setFollowDate(oneDayBeforeMoveIn);
                setCalendarRestrictions({
                    followMinDate: tomorrow,
                    followMaxDate: null,
                });
            }
        }
    }, [moveInDate]);
    return (
        <Box sx={{ width: '100%', minWidth: 0 }}>
            <CustomAccordion defaultExpanded>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                >
                    <Typography variant="h3" color="text.secondary">Update/Change Reservation</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid2 container spacing={2} columns={12}>
                        {/* First section: Update Tenant Information */}
                        <Grid2 size={{ xs: 12, sm: 4 }}>
                            <Stack mb={2} direction='row' spacing={2} justifyContent={'space-between'} alignItems={'center'} useFlexGap>
                                <Typography variant='h3' color='text.secondary'>Update Tenant Information</Typography>
                                {onLookupTenant && (
                                    <Link sx={{ color: '#2400cb', fontWeight: 500, cursor: 'pointer', fontStyle: 'italic' }} onClick={onLookupTenant}>Lookup Occupant</Link>
                                )}
                            </Stack>
                            <Grid2 container spacing={2} columns={12}>
                                <Grid2 size={{ xs: 12, md: 12 }}>
                                    <TextField
                                        id="First-name"
                                        name="firstname"
                                        label="First Name"
                                        variant="outlined"
                                        size="small"
                                        value={formData.firstname}
                                        onChange={handleChange}
                                        error={errors.firstname}
                                        helperText={errors.firstname ? "Invalid First name field" : ""}
                                        sx={{ width: '290px' }}
                                    />
                                </Grid2>
                                <Grid2 size={{ xs: 12, md: 12 }}>
                                    <TextField
                                        id="Last-name"
                                        name="lastname"
                                        label="Last Name"
                                        variant="outlined"
                                        size="small"
                                        value={formData.lastname}
                                        onChange={handleChange}
                                        error={errors.lastname}
                                        helperText={errors.lastname ? "Invalid Last name field" : ""}
                                        sx={{ width: '290px' }}
                                    />

                                </Grid2>
                                <Grid2 size={{ xs: 12, md: 12 }}>
                                    <TextField
                                        id="Phone-number"
                                        name="phNum"
                                        label="Phone Number"
                                        variant="outlined"
                                        size="small"
                                        value={formData.phNum}
                                        onChange={handleChange}
                                        onBlur={handlePhoneBlur}
                                        error={errors.phNum}
                                        helperText={errors.phNum ? "Enter a valid 10-digit phone number" : ""}
                                        inputProps={{ maxLength: 14, inputMode: 'numeric' }}
                                        sx={{ width: '290px' }}
                                    />
                                </Grid2>
                                <Grid2 size={{ xs: 12, md: 12 }}>
                                    <TextField
                                        id="email"
                                        name="email"
                                        label="Email"
                                        variant="outlined"
                                        size="small"
                                        value={formData.email}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={errors.email}
                                        helperText={errors.email ? "Invalid email address" : ""}
                                        sx={{ width: '290px' }}
                                    />
                                </Grid2>
                            </Grid2>
                        </Grid2>

                        <Divider orientation='vertical' flexItem />

                        {/* Second section: Reservation Information */}
                        <Grid2 size={{ xs: 12, sm: 4 }}>
                            <Typography mb={2} variant="h3" color="text.secondary">
                                Update Reservation Information
                            </Typography>
                            <Grid2 my={2} container spacing={2} columns={12} alignItems="flex-start">
                                {/* Row 1: Type, Unit Size, Current Deal Price */}
                                <Grid2 size={{ xs: 12, md: 4 }}>
                                    <List>
                                        <ListItem>
                                            <ListItemText primary='Type' secondary={selectedUnit.productType} />
                                        </ListItem>
                                    </List>
                                </Grid2>
                                <Grid2 size={{ xs: 12, md: 4 }}>
                                    <List>
                                        <ListItem>
                                            <ListItemText primary='Unit Size' secondary={selectedUnit.unitSize || 'N/A'} />
                                        </ListItem>
                                    </List>
                                </Grid2>
                                <Grid2 size={{ xs: 12, md: 4 }}>
                                    <List>
                                        <ListItem>
                                            <ListItemText
                                                primary={'Current Deal Price'}
                                                secondary={`$${(showNewProductTypeMsg ? (Number(updatedDealPrice) || 0) : (reservationDetails?.deal?.quoted_price ?? 0)).toFixed(2)}`}
                                            />
                                        </ListItem>
                                    </List>
                                </Grid2>
                                {/* Row 2: Promotion, Features, Unit Price */}
                                <Grid2 size={{ xs: 12, md: 4 }}>
                                    <List>
                                        <ListItem>
                                            <ListItemText
                                                primary='Promotion'
                                                secondary={
                                                    selectedUnit.promotion ||
                                                    (selectedUnit.external_promotion_id
                                                        ? `Promotion #${selectedUnit.external_promotion_id}`
                                                        : 'No Promotion')
                                                }
                                            />
                                        </ListItem>
                                    </List>
                                </Grid2>
                                <Grid2 size={{ xs: 12, md: 4 }}>
                                    <List>
                                        <ListItem>
                                            <ListItemText primary="Features" secondary={formatUnitFeatures(selectedUnit)} />
                                        </ListItem>
                                    </List>
                                </Grid2>
                                <Grid2 size={{ xs: 12, md: 4 }}>
                                    <List>
                                        <ListItem>
                                            <ListItemText
                                                primary="Unit Price"
                                                secondary={`$${(Number(effectiveUnitType?.price ?? selectedUnit.rate) || 0).toFixed(2)}`}
                                            />
                                        </ListItem>
                                    </List>
                                </Grid2>
                                {/* Row 3: Unit Number */}
                                <Grid2 size={{ xs: 12, md: 4 }}>
                                    <List>
                                        <ListItem>
                                            <Autocomplete
                                                disablePortal
                                                options={unitOptions}
                                                getOptionLabel={(option) => option.unit_number ? option.unit_number.toString() : "No Unit"}
                                                value={selectedUnit?.external_unit_id ? unitOptions.find(item => item.external_id === selectedUnit.external_unit_id) ?? null : null}
                                                isOptionEqualToValue={(option, value) => option?.external_id === value?.external_id}
                                                onChange={handleUnitChange}
                                                loading={isLoading}
                                                sx={{ width: '100%', minWidth: 150 }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Unit Number"
                                                        size="small"
                                                        InputProps={{
                                                            ...params.InputProps,
                                                            endAdornment: (
                                                                <>
                                                                    {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                                                    {params.InputProps.endAdornment}
                                                                </>
                                                            ),
                                                        }}
                                                    />
                                                )}
                                            />
                                        </ListItem>
                                    </List>
                                </Grid2>
                                {/* Messages span all 3 columns */}
                                {showNoLongerAvailableError && noOthersAvailable && (
                                    <Grid2 size={{ xs: 12, md: 12 }}>
                                        <Typography variant="body2" color="error">
                                            Select a new unit using the Available Units below.
                                        </Typography>
                                    </Grid2>
                                )}
                                <Grid2 size={{ xs: 12, md: 12 }}>
                                    <Link sx={{ color: '#2400cb;', fontWeight: 500, cursor: 'pointer', fontStyle: 'italic' }} onClick={handleLookupTenant}>
                                        Available Units
                                    </Link>
                                </Grid2>
                            </Grid2>
                        </Grid2>
                        <Divider orientation='vertical' flexItem />
                        <Grid2 size={{ xs: 12, sm: 3 }}>
                            <Typography mb={2} variant="h3" color="text.secondary">
                                Update Move-in Date
                            </Typography>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="Move-in Date"
                                    value={moveInDate}
                                    onChange={(newValue) => setMoveInDate(newValue)}
                                    minDate={dayjs(moveInMinDates)}
                                    maxDate={dayjs().add(maxdate, 'day')}
                                    slotProps={{
                                        textField: {
                                            size: 'small',
                                        },
                                    }}
                                />
                            </LocalizationProvider>

                            <Typography mb={2} variant="h3" color="text.secondary">
                                Update Follow-Up Date
                            </Typography>

                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="Follow-Up Date"
                                    value={FollowDate}
                                    onChange={(newValue) => {
                                        setFollowDate(newValue);
                                        // Clear error when date is selected
                                        if (newValue && newValue.isValid()) {
                                            setErrors({
                                                ...errors,
                                                followupDate: false,
                                            });
                                        }
                                    }}
                                    minDate={calendarRestrictions.followMinDate || undefined} // Replace null with undefined
                                    maxDate={calendarRestrictions.followMaxDate || undefined} // Replace null with undefined
                                    slotProps={{
                                        textField: {
                                            size: 'small',
                                            error: errors.followupDate,
                                            helperText: errors.followupDate ? 'Follow-up date is required' : '',
                                        },
                                    }}
                                />
                            </LocalizationProvider>

                        </Grid2>
                    </Grid2>
                    {/* Update Button below the three sections */}
                    <Box mt={3} mb={2}>
                        <Divider sx={{ pt: -5, mb: 2 }} />
                        <Box mt={3} mb={2}>
                            <Box display="flex" justifyContent="space-between" alignItems="center" gap={2} flexWrap="wrap">
                                <Typography component="span" sx={{ fontStyle: 'italic', color: 'text.secondary' }}>
                                    Changes to tenant, unit, price or dates do not take affect until the Update button is selected.
                                </Typography>
                                <Box display="flex" alignItems="center" gap={2}>
                                {/* Modify Link */}
                                <Link
                                    onClick={handleRentNavigate}
                                    className="modify-link"
                                >
                                    Convert
                                </Link>
                                <Link
                                    onClick={() => navigate(`/Dashboard/${facilityId}`)}
                                    className="modify-link"
                                    sx={{ cursor: 'pointer', color: 'text.secondary', fontWeight: 'bold' }}
                                >
                                    Back
                                </Link>
                                {/* Update Button */}
                                <Button
                                    variant='contained'
                                    color='primary'
                                    onClick={handleUpdate}
                                    disabled={loading}
                                >
                                    {loading ? <CircularProgress size={24} color="inherit" /> : 'Update'}
                                </Button>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </AccordionDetails>
            </CustomAccordion>
            {isLookup ? (
            <Box sx={{ width: '100%', minWidth: 0 }}>
            <CustomAccordion defaultExpanded sx={{ width: '100%' }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                >
                    <div id="occupant-info">
                        <Typography variant="h3" color="text.secondary">Pick a Different Unit
                        </Typography>
                    </div>
                </AccordionSummary>
                <AccordionDetails sx={{ width: '100%', minWidth: 0, overflow: 'hidden', display: 'block' }}>
                    <Box py={2} sx={{ width: '100%', minWidth: 0, overflow: 'auto' }}>
                        {isLoading ? (
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "70vh",
                                }}
                            >
                                <CircularProgress />
                            </Box>
                        ) : (
                            <DataGrid
                                rows={rowData}
                                columns={colDefs}
                                disableColumnMenu
                                sx={{
                                    width: '100%',
                                    minWidth: 0,
                                    '& .MuiDataGrid-row.current-size-row': {
                                        backgroundColor: '#fffde7',
                                    },
                                }}
                                getRowClassName={(params) => (shouldHighlightRow(params.row) ? 'current-size-row' : '')}
                                getRowHeight={(params) => {
                                    const row = rowData.find((r) => r.id === params.id);
                                    if (!row) return null;
                                    const featureCount = [
                                        row.floor === 1 || (row.floor !== undefined && row.floor > 1),
                                        row.inside === 1,
                                        row.drive_up === 1,
                                        row.climate === 1,
                                        row.air_cooled === 1,
                                        row.heated === 1,
                                        row.elevator === 1,
                                        row.stair_access === 1,
                                    ].filter(Boolean).length;
                                    return featureCount > 6 ? 80 : null;
                                }}
                                slots={{
                                    noResultsOverlay: CustomNoResultsOverlay,
                                }}
                                hideFooterPagination
                                autoHeight
                            />
                        )}
                    </Box>
                </AccordionDetails>
            </CustomAccordion>
            </Box>
            ) : null}

        </Box>
    );
}

export default UpdateReservation;
